import React from "react";
import { SanityMissionStatement } from "../../model/common";
import { imageUrlBuilder } from "../../utils/images";
import styles from "./MissionStatementGrid.module.scss";
import Text from "../Text/Text";

interface MissionStatementGridProps {
  node: {
    missionStatements: SanityMissionStatement[];
  };
}
const MissionStatementGrid = ({
  node: { missionStatements }
}: MissionStatementGridProps) => (
  <div className={styles.root}>
    {missionStatements.map(({ logo, statement, description }) => (
      <div className={styles.statement}>
        <div className={styles.imgContainer}>
          <img src={imageUrlBuilder.image(logo).url()!} alt={statement} />
        </div>
        <Text variant="h3" as="div">
          {statement}
        </Text>
        <Text variant="defaultLight">{description}</Text>
      </div>
    ))}
  </div>
);

export default MissionStatementGrid;
